// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__klpMx","fullView":"styles_fullView___75Sc"};